export const dataHooks = {
    tooltip: 'infoicon-tooltip',
};
//# sourceMappingURL=constants.js.map